import styled from 'styled-components';
import {
  white, blueOpaque, teko, tekoMedium,
} from '../../../utils/theme';
import { mobile } from '../../../utils/breakpoints';
import { WhiteButton } from '../../../utils/atoms';

export const ReadMoreLink = styled(WhiteButton)`
  padding: 9px 9px 6px 9px;
`;

export const ArticleSlideWrapper = styled.div`
  position: relative;
  
  &::after {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }
  
  .article-bg {
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  @media (max-width: ${mobile.max}px) {
    &:before {
      content: ' ';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 50%, #000000 100%);
    }
  }

  .xfl-article-slide {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    
    &__content {
      align-items: flex-start;
      background-color: ${blueOpaque};
      display: flex;
      flex-direction: column;
      padding: 30px;
      position: absolute;
      right: 0;
      text-align: left;
      top: 50%;
      transform: translateY(-50%);
      width: 480px;
      color: ${white};

      h4 {
        margin-bottom: 15px;
        ${teko} font-size: 28px;
      }

      h3 {
        margin-bottom: 30px;
        ${tekoMedium} font-size: 40px;
      }

      @media (max-width: ${mobile.max}px) {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        transform: none;

        h3 {
          font-size: 20px;
        }

        h3 {
          ${tekoMedium} font-size: 24px;
          line-height: 29px;
          letter-spacing: 3px;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/hero-carousel/styles/articleSlide.style.js